export default {
    data() {
        return {
            basket_timer: {
                interval: false,
                expires_in: -1,
            }
        }
    },
    mounted() {
        this.basket_timer.interval = setInterval(() => {
            var state = this.$store.state.basket;
            if (state.allocated) {
                if (state.expires_at) {
                this.basket_timer.expires_in = Math.ceil((state.expires_at - new Date().getTime()) / 1000);

                if (this.basket_timer.expires_in === 0) {
                    this.$emit('basket-expired');
                } else if (this.basket_timer.expires_in < (10 * 60)) {
                    this.$emit('basket-expiring-soon-10');
                } else if (this.basket_timer.expires_in < (30 * 60)) {
                    this.$emit('basket-expiring-soon-30');
                }

            }
            }
        }, 1000);
    },
    destroyed() {
        if (this.basket_timer.interval) {
            clearInterval(this.basket_timer.interval);
            this.basket_timer.interval = false;
        }
    }
}